import { render, staticRenderFns } from "./TreatmentSetNew.vue?vue&type=template&id=cd7174b2&scoped=true&"
import script from "./TreatmentSetNew.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetNew.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetNew.vue?vue&type=style&index=0&id=cd7174b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7174b2",
  null
  
)

export default component.exports